export default "__VITE_ASSET__bd493e84__"